








































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header/main-header.vue";
import Pagination from "@/components/paginaiton.vue";
import PreviewDialog from "../components/previewDialog.vue";
import ComprehensiveExportDialog from "@/views/storehouse/case/components/comprehensive-export-dialog.vue";
import { GetDataTables, ExportTable, DeleteTable, GetComprehensiveExportList } from "@/request/export";
@Component({
  components: {
    MainHeader,
    Pagination,
    PreviewDialog,
    ComprehensiveExportDialog,
  },
})
export default class Name extends Vue {
  private activeTab: string = "批量导出";
  private filters: any = {
    search: "",
    totalPage: 0,
    totalCount: 0,
    pageCount: 10,
    currentPage: 1,
  };
  private ifShowPreview: boolean = false;
  private ifShowComprehensiveExport: boolean = false;
  private tempTableId: any = "";
  private messages: any[] = [];
  private get configuration() {
    return this.$store.state.configuration;
  }
  /**
   * @description 切换 tab
   */
  private changeTab(tab: string) {
    if (this.activeTab === tab) {
      return;
    }
    this.activeTab = tab;
    this.filters.search = "";
    this.filters.currentPage = 1;
    this.fetchList();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.currentPage = 1;
    this.fetchList();
  }
  /**
   * @description 导出
   */
  private exportOne(table: any) {
    const loading = this.$loading({
      lock: true,
      text: "导出中",
      spinner: "el-icon-loading",
    });
    const params: any = {
      table_id: table.table_id,
    };
    ExportTable(this, params, loading)
      .then((data: any) => {
        loading.close();
        window.open(
          window.API_ROOT + "api/wajue/download?filename=" + data.file_name
        );
      })
      .catch((err) => {
        loading.close();
      });
  }
  /**
   * @description 整理综合导出列表展示字段
   */
  private normalizeComprehensiveList(list: any[]) {
    const statusMap: any = {
      pending: "进行中",
      success: "导出成功",
      failed: "导出失败",
    };
    return (list || []).map((item: any) => {
      const rawItems =
        item.export_items != null ? item.export_items : item["导出项目"];
      return {
        ...item,
        exportItemsText: Array.isArray(rawItems)
          ? rawItems.join("、")
          : rawItems || "",
        exportStatusText:
          item["导出状态"] || statusMap[item.status] || item.status || "",
        exportRowCount: item.row != null ? item.row : item["数据条数"],
      };
    });
  }
  /**
   * @description 下载综合导出文件
   */
  private downloadComprehensive(row: any) {
    if (!row.oss_url) {
      this.$message.warning("暂无可下载文件");
      return;
    }
    window.open(row.oss_url);
  }
  /**
   * @description 删除
   */
  private deleteOne(table: any) {
    this.$confirm("确定要删除吗？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const params: any = {
        data: {
          table_id: table.table_id,
        },
      };
      DeleteTable(this, params).then((data: any) => {
        this.$message.success("删除成功");
        this.fetchList();
      });
    });
  }
  /**
   * @description 查看
   */
  private checkOne(table: any) {
    this.tempTableId = table.table_id;
    this.ifShowPreview = true;
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val: any) {
    this.filters.currentPage = val;
    this.fetchList();
  }
  /**
   * @description 处理翻页器的每页条数变化
   */
  private handleCurrentSizeChange(val: any) {
    this.filters.currentPage = 1;
    this.filters.pageCount = val;
    this.fetchList();
  }
  /**
   * @description 综合导出提交后刷新列表
   */
  private onComprehensiveExportConfirm() {
    this.fetchList();
  }
  /**
   * @description 获取列表
   */
  private fetchList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.activeTab === "综合导出") {
      const params: any = {
        params: {
          page: this.filters.currentPage,
          page_size: this.filters.pageCount,
        },
      };
      GetComprehensiveExportList(this, params, loading)
        .then((data: any) => {
          this.messages = this.normalizeComprehensiveList(data.data || []);
          this.filters.totalCount = data.total || 0;
        })
        .finally(() => {
          loading.close();
        });
      return;
    }
    const params: any = {
      params: {
        current_page: this.filters.currentPage,
        page_count: this.filters.pageCount,
        sort_field: "创建时间",
        sort_value: 0,
        search: this.filters.search,
      },
    };
    GetDataTables(this, params)
      .then((data: any) => {
        this.messages = data.tables;
        this.filters.totalCount = data.total_count;
        this.filters.totalPage = data.total_page;
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchList();
  }
}
